import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/** One yes / no question. `isDanger` makes the confirm button the error colour (deleting, discarding, cancelling). */
export interface ConfirmDialogQuestion {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel?: string;
  isDanger?: boolean;
}

interface ConfirmDialogProps {
  question: ConfirmDialogQuestion | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/** A confirm dialog: open while `question` is set; the cancel button has focus, Esc cancels. */
export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { question, onConfirm, onCancel } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      onClose={onCancel}
      open={question !== null}
    >
      <DialogTitle>{question?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{question?.body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={onCancel}
        >
          {question?.cancelLabel ?? "Cancel"}
        </Button>
        <Button
          color={question?.isDanger ? "error" : "primary"}
          disableElevation
          onClick={onConfirm}
          variant="contained"
        >
          {question?.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
